import api from './api';

const service = {
  fetch: params => api.get('blacklist-domains', params),
  fetchById: id => api.get(`blacklist-domains/${id}`),
  blacklistDomain: params => api.post('blacklist-domains', params),
  unblacklistDomain: id => api.delete(`blacklist-domains/${id}`),
  update: blacklistDomain =>
    api.put(`blacklist-domains/${blacklistDomain.id}`, blacklistDomain),
};

export default service;
